import React, { useEffect } from 'react';
import Plotter from './plotter';

const reOrder = (values) => {

    if(values.length === 0) {
        return values;
    }

    return [
        values[2],
        values[3],
        values[4],
        values[5],
        values[6],
        values[7],
        values[0],
        values[1],
    ];
}

const reOrderLabels = (values) => {

    if(values.length === 0) {
        return values;
    }

    console.log(values)

    return [
        values[2],
        values[1],
        values[0],
        values[3],
        values[7],
        values[6],
        values[5],
        values[4],
    ];
}

const RadarChart = ({ labels, chart1, chart2 = [] }) => {
  const containerId = 'candidate-chart';

  labels = reOrderLabels(labels);
  chart1 = reOrder(chart1);
  chart2 = reOrder(chart2);

  useEffect(() => {
    const plotter = new Plotter(
      labels,
      {
        w: 350,
        h: 350,
        levels: 5,
        maxValue: 100,
        showTooltip: false,
        color: 'rgb(17, 43, 79)',
        ExtraWidthX: 40,
        ExtraWidthY: 40
      },
      [chart1]
    );

    plotter.plot(`#${containerId}`, [chart1], '', [chart2]);
  });

  return <div style={{ height: '390px', width: '100%', display: 'flex', justifyContent: 'center' }} id={containerId} />;
};

export default RadarChart;
